import React from "react";
import "./LegalPages.css";

export default function CookiePolicy() {
  return (
    <div className="pp-legal-page">
      <div className="pp-container">
        <div className="pp-legal-shell">
          <div className="pp-legal-hero">
            <div className="pp-legal-badge">Cookie Policy</div>
            <h1>How PresentPlus uses cookies and local storage</h1>
            <p>
              PresentPlus uses limited browser technologies to improve security,
              authentication reliability, session continuity and platform performance.
            </p>
          </div>

          <div className="pp-legal-content">
            <section>
              <h2>Authentication & Security</h2>
              <p>
                Cookies and secure browser storage may be used to maintain secure login sessions,
                support MFA, detect suspicious activity and protect against abuse.
              </p>
            </section>

            <section>
              <h2>Performance & Experience</h2>
              <p>
                Local storage may support interface preferences, theme settings,
                device continuity and a smoother user experience.
              </p>
            </section>

            <section>
              <h2>Third-Party Services</h2>
              <p>
                PresentPlus may use trusted infrastructure services including Firebase
                for authentication, hosting, storage, analytics and operational reliability.
              </p>
            </section>

            <section>
              <h2>Control</h2>
              <p>
                Most browsers allow users to manage or disable cookies. Disabling essential
                cookies may affect authentication and platform functionality.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
